import React from "react";
import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import SEO from "../components/SEO";
import Brands from "../components/Brands";
import { MapPin, ArrowRight } from "lucide-react";
import { SITE_URL } from "../lib/site";
import { serviceAreas } from "../data/serviceAreas";

const ALL = [{ slug: "rocky-mount", city: "Rocky Mount", county: "Nash County", path: "/rocky-mount-nc" },
  ...serviceAreas.map((a) => ({ ...a, path: `/${a.slug}-nc` }))];

const ServiceAreasIndex = () => {
  const title = "Service Areas — AV & Home Theater Installation Across Eastern NC";
  const desc = "Set Up Home Theater provides professional TV, home theater, audio, commercial AV and smart home installation across Rocky Mount, Wilson, Greenville, Raleigh and Eastern North Carolina.";
  const itemList = {
    "@context": "https://schema.org", "@type": "ItemList",
    itemListElement: ALL.map((a, i) => ({ "@type": "ListItem", position: i + 1, name: `${a.city}, NC`, url: `${SITE_URL}${a.path}` })),
  };
  const breadcrumb = {
    "@context": "https://schema.org", "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` },
      { "@type": "ListItem", position: 2, name: "Service Areas", item: `${SITE_URL}/service-areas` },
    ],
  };

  return (
    <main data-testid="service-areas-index">
      <SEO title={title} description={desc} path="/service-areas" jsonLd={[itemList, breadcrumb]} />
      <PageHeader
        breadcrumb="Home / Service Areas"
        title="Areas We Serve Across Eastern North Carolina"
        subtitle="Local, licensed and insured AV and home theater installation — from Rocky Mount and Wilson to Greenville, Raleigh and beyond."
      />
      <section className="section-pad">
        <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {ALL.map((a) => (
              <Link key={a.slug} to={a.path} data-testid={`area-card-${a.slug}`} className="group bg-white rounded-2xl border border-slate-200 p-6 hover:shadow-lg hover:-translate-y-0.5 transition-all">
                <span className="w-10 h-10 rounded-full bg-[#eef4ff] flex items-center justify-center"><MapPin className="w-5 h-5 text-[#3b9dff]" /></span>
                <h2 className="text-lg font-bold text-[#0a1f44] mt-4">{a.city}, NC</h2>
                <p className="text-sm text-slate-500 mt-1">{a.county}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-[#3b9dff] text-sm font-semibold">View {a.city} services <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Brands />
    </main>
  );
};

export default ServiceAreasIndex;
